<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      selectShowPower="/merchantactivationexamine/select"
      :showDownloadPower="true"
      showDownloadPowerType="purple"
      downloadPowerText="重新统计"
      downloadPower="/merchantactivationexamine/tj"
      @down="down"
      :show="false"
    >
      <el-form-item label="代理商ID">
        <el-input v-model="formModel.agentId" placeholder="请输入"></el-input>
      </el-form-item>
      <!-- <el-form-item label="代理商姓名">
        <el-input v-model="formModel.agentName" placeholder="请输入"></el-input>
      </el-form-item> -->
      <el-form-item label="代理商手机号">
        <el-input
          v-model="formModel.agentPhone"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="状态" prop="status">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in status"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="batchId"
        label="批次号"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="agentId"
        label="代理商ID"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="agentName"
        label="代理商姓名"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="agentPhone"
        label="代理商手机号"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="standard"
        label="标准"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
      </el-table-column>
      <el-table-column
        prop="number"
        label="达标数量"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="money"
        label="分润金额(元)"
        min-width="120"
        :formatter="formatterTableNumber"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableDataStatus"
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="190"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="审核时间"
        min-width="190"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="processName"
        label="审核人"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        v-if="hasPerm('/merchantactivationexamine/sh')"
        label="操作"
        min-width="160"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="scope.row.status == 1"
            @click="openAddDialog(scope.row)"
            >审核
          </el-button>
          <el-button type="text" disabled v-else>已审核</el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      formDialogTitle="审核"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="120px"
    >
      <el-form-item label="审核" prop="status">
        <el-radio-group v-model="dialogModel.status">
          <el-radio :label="2">通过</el-radio>
          <el-radio :label="3">驳回</el-radio>
        </el-radio-group>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";

import TransactionService from "service/TransactionService";

import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "merchantactivationexamine",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    ShowInfoDialog,
  },
  data() {
    return {
      show: false,
      formModel: {
        agentId: "",
        agentPhone: "",
        // agentName: "",
        // status: "",
        time: "",
      },
      tableData: [],
      submitService: TransactionService.merchantactivationexamineList,
      itemId: "",
      dialogModel: {
        status: 2, //审核
      },
      status: [
        {
          id: "",
          value: "全部",
        },
        {
          id: "1",
          value: "待审核",
        },
        {
          id: "2",
          value: "通过",
        },
        {
          id: "3",
          value: "驳回",
        },
      ],
      dialogRules: {
        status: [
          {
            required: true,
            message: "请选择",
          },
        ],
      },
      page: {},
      isPage: false,
      isFlag: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      this.params = {
        agentId: this.formModel.agentId,
        // agentName: this.formModel.agentName,
        agentPhone: this.formModel.agentPhone,
        // status: this.formModel.status,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.formModel.time.length) {
        this.params.startDate = this.formModel.time[0];
        this.params.endDate = this.formModel.time[1];
      }
      return this.params;
    },
    dialogData() {
      const params = {
        status: this.dialogModel.status,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return TransactionService.merchantactivationexamineSh;
      //   if (this.flag == 1) {

      //   } else if (this.flag == 2) {
      //     return TransactionService.merchantactivationexamineEdit;
      //   } else if (this.flag == 3) {
      //     return TransactionService.merchantactivationexamineTj;
      //   }
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {
    load() {
      this.formModel = {
        time: "",
        // status: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    openAddDialog(item) {
      this.itemId = item ? item.id : "";
      this.$refs.formDialog.open();
    },

    dialogClose() {
      this.dialogModel = {
        status: 2,
      };
      this.itemId = "";
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res;
        this.tableData = result.contents.rows;
        this.page.currentPage = result.contents.current;
        this.page.total = result.contents.total;
        this.page.pageSize = result.contents.size;
      });
    },
    down() {
      this.showConfirm("是否执行?")
        .then(() => {
          this.doLoad(
            TransactionService.merchantactivationexamineTj,
            "",
            (res) => {
              this.doCheck(res, (res) => {
                this.commonSuccess(res);
              });
            },
            "信息获取失败"
          );
        })
        .catch(() => {});
    },
    formatterTableDataStatus(row, column, cellValue, index) {
      let value = "--";
      this.status.forEach((item) => {
        if (item.id == cellValue) {
          value = item.value;
        }
      });
      return value;
    },
  },
};
</script>

<style scoped>
.button {
  width: 50px;
  padding: 11px 10px;
  margin-left: 49px;
  display: block;
  float: left;
}

.text {
  width: 145px !important;
  margin-left: 12px;
  float: left;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}
.chenk {
  width: 60px;
  position: relative;
  top: -61px;
  left: 189px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/Transaction/MerchantActivationExamine.vue